import { Text, View } from '@react-pdf/renderer';

export const PdfCoApplicantInformation = (account, styles) => {
  const { grdRow, grdCell, grdHeader, BB, BL, BR, label, text, nM } = styles;

  return (
    <View style={[grdCell]}>
      <View style={[grdHeader]}>
        <Text>Co-Applicant Information</Text>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>First Name:</Text>
          <Text style={[text]}>{account.jointOwner.firstName}</Text>
        </View>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>Middle Name:</Text>
          <Text style={[text]}>{account.jointOwner.middleName}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
          <Text style={label}>Last Name:</Text>
          <Text style={[text]}>{account.jointOwner.lastName}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 50 }]}>
          <Text style={label}>Email Address:</Text>
          <Text style={[text]}>{account.jointOwner.email}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
          <Text style={label}>Phone Number:</Text>
          <Text style={[text]}>{account.jointOwner.phone}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 50 }]}>
          <Text style={label}>Address:</Text>
          <Text style={[text]}>
            {account.jointOwner.address1} {account.jointOwner.address2}
          </Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 50 }]}>
          <Text style={label}>City:</Text>
          <Text style={[text]}>{account.jointOwner.city}</Text>
        </View>
      </View>
      <View style={[grdRow, nM]}>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>State:</Text>
          <Text style={[text]}>{account.jointOwner.state}</Text>
        </View>
        <View style={[grdCell, BB, BL, { width: 33.33 }]}>
          <Text style={label}>Zip Code:</Text>
          <Text style={[text]}>{account.jointOwner.zip}</Text>
        </View>
        <View style={[grdCell, BB, BL, BR, { width: 33.33 }]}>
          <Text style={label}>Country:</Text>
          <Text style={[text]}>{account.jointOwner.country}</Text>
        </View>
      </View>
    </View>
  );
};
